module.exports = __webpack_public_path__ + "img/CD.df845267.svg";